// import { Tabs } from "@mantine/core";
// import { useState } from "react";
// import WebDevelopment from "./subComponents/WebDevelopment";
// import MobileAppDevelopment from "./subComponents/MobileAppDevelopment";
// import BackendDevelopment from "./subComponents/BackendDevelopment";
// import UiUxDesign from "./subComponents/UiUxDesign";
import ServicesCard from "../../components/ServicesCard";
import { motion } from "framer-motion";

const Services = () => {
  // const [selectedTab, setSelectedTab] = useState("frontend");
  // const data = [
  //   {
  //     value: "frontend",
  //     text: "Web Development",
  //   },
  //   {
  //     value: "mobile",
  //     text: "Mobile Application Development",
  //   },
  //   {
  //     value: "backend",
  //     text: "Game Development",
  //   },
  //   {
  //     value: "uiux",
  //     text: "UI/UX Design",
  //   },
  // ];

  // function handleMouseEvent(value: string) {
  //   setSelectedTab(value);
  // }

  const techData = [
    {
      id: 1,
      href: "web-development",
      title: "Web Development",
      content:
        "As a leading web development company, we build modern, scalable web applications using cutting-edge technologies like React.js, Next.js, Vue.js, Node.js, TypeScript, and serverless architectures. We create Progressive Web Apps (PWAs), implement microservices, deploy on cloud platforms, and ensure optimal performance.",
      iconLink: "/Technology_Images/webDevelopmentSVG.svg",
    },
    {
      id: 2,
      href: "mobile-app-development",
      title: "Mobile App Development",
      content:
        "With over a decade of expertise, Nexasoft delivers cutting-edge mobile applications for iOS and Android using React Native, Flutter, Swift, and Kotlin. We build scalable apps with modern architecture patterns, integrate cloud services, implement advanced security, and ensure seamless user experiences.",
      iconLink: "/Technology_Images/androidSVG.svg",
    },
    {
      id: 3,
      href: "game-development",
      title: "Game Development",
      content:
        "Nexasoft is an acclaimed game development studio skilled in Unity, Unreal Engine, and Godot. We create immersive games for mobile, PC, console, and VR/AR platforms with advanced graphics, AI-powered features, multiplayer capabilities, and live services that maximize player engagement.",
      iconLink: "/Technology_Images/GameIcon.svg",
    },
    {
      id: 4,
      href: "ui-ux-design",
      title: "UI/UX Design",
      content:
        "UI/UX is the heart of any application. Our design team creates user-centered interfaces using modern design systems, comprehensive user research, and data-driven design decisions. We build scalable design systems, ensure accessibility compliance, and deliver pixel-perfect, responsive interfaces.",
      iconLink: "/Technology_Images/UiUxIcon.svg",
    },
  ];

  return (
    <div className="relative bg-gradient-to-br from-neutral-950 via-neutral-900 to-neutral-950 px-p83 bg-cover pb-12 500:pb-16 min-h-[90vh] flex flex-col justify-center overflow-hidden" id="services">
      {/* Subtle background accent */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent-orange/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2 pointer-events-none" />
      <motion.div
        className="text-center pt-8 500:pt-12 pb-6 500:pb-8"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h1 className="text-2xl 500:text-3xl 700:text-4xl font-merry-bold tracking-tight">
          We're Providing{" "}
          <span className="font-bold text-primary-500 block 500:inline">
            High Quality Services
          </span>
        </h1>
        <motion.p
          className="text-neutral-300 text-sm 500:text-base mt-3 font-poppins-regular max-w-2xl mx-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          Delivering excellence through innovative solutions tailored to your
          business needs
        </motion.p>
      </motion.div>

      <div className="grid 550:grid-cols-2 900:grid-cols-3 1600:grid-cols-4 gap-4 500:gap-6 700:gap-8">
        {techData.map(({ id, title, href, iconLink, content }, index) => (
          <motion.div
            key={id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <ServicesCard
              title={title}
              content={content}
              iconLink={iconLink}
              href={href}
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Services;
